<template>
  <div>
    <vs-table hoverFlat id="order_item_table" :data="product_order_items">

      <template slot="thead">
        <vs-th width="10%">ITS PRODUCT CODE/NAME</vs-th>
        <vs-th width="10%">CUSTOMER ITEM CODE/NAME</vs-th>
        <vs-th width="5%">QUANTITY (KG)</vs-th>
        <vs-th width="5%">UNIT PRICE Excl VAT (KG/{{account_currency}})</vs-th>
        <vs-th width="5%">PACK SIZE (KG)</vs-th>
        <vs-th width="10%">INCOTERM</vs-th>
        <vs-th width="7%">EMD</vs-th>
        <vs-th width="5%">REQUIRED BY DATE</vs-th>
        <vs-th width="5%">SHIP BY DATE</vs-th>
        <vs-th width="8%">TOTAL PRICE Excl VAT ({{account_currency}})</vs-th>
        <vs-th width="10%" class="text-xs">SO ITEM STATUS</vs-th>
        <vs-th width="5%" class="text-xs">WO STATUS</vs-th>
        <vs-th width="5%" class="text-xs">IS OTIF</vs-th>
        <vs-th width="10%">ACTION</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">

          <vs-td :data="data[indextr].formulation_code">
            <span class="cursor-pointer">
              <a @click.stop="onClickFinishedProduct(data[indextr].formulation_id)">
                {{ data[indextr].formulation_code }}
                <br>
            {{ data[indextr].formulation_name }}
              </a>
            </span>
          </vs-td>

          <vs-td>
            <div v-if="data[indextr].customer_item_code !== 'N/A'">
              <span class="font-bold">{{ data[indextr].customer_item_code}}</span> <br>
              {{ data[indextr].customer_item_name }}
            </div>
            <div v-else> N/A </div>
          </vs-td>

          <vs-td :data="data[indextr].quantity">
            {{ Number(data[indextr].quantity).toFixed(3) | remove_trailing_zeros }}
          </vs-td>

          <vs-td :data="data[indextr].price">
            {{ (Number(data[indextr].price)).toFixed(2) }}
          </vs-td>

          <vs-td :data="data[indextr].pack_size">
            {{ data[indextr].pack_size | remove_trailing_zeros}}
          </vs-td>

          <vs-td :data="data[indextr].incoterm">
            <vs-dropdown >

              <a class="flex items-center">
                {{ data[indextr].incoterm || 'SELECT'}}
                <i class="material-icons"> expand_more </i>
              </a>

              <vs-dropdown-menu style="z-index: 99999">

                <vs-dropdown-item @click="onClickIncoterm(incoterm.code, data[indextr].id)" v-for="(incoterm, index) in incoterms" :key="index">
                  <span>{{ incoterm.code }}</span>
                </vs-dropdown-item>

              </vs-dropdown-menu>
            </vs-dropdown>
          </vs-td>

          <vs-td>
            {{ manufacturingDateFactory(data[indextr].work_orders) }}
          </vs-td>

          <vs-td>
            {{ data[indextr].required_by || 'N/A' }}
          </vs-td>

          <vs-td>
            {{ data[indextr].shipment_date || 'N/A' }}
          </vs-td>

          <vs-td class="mr-10" :data="data[indextr].price">
            {{data[indextr].quantity ? (Number(data[indextr].price) * data[indextr].quantity).toFixed(2) : '0.00'}}
          </vs-td>

          <vs-td :data="data[indextr].item_status">
<!--            :disabled="isInPackOffCompleted(data[indextr].work_orders, data[indextr].item_status)"-->
            <vs-dropdown class="cursor-pointer" v-if="$can('create-edit-order')">
              <a class="flex items-center text-dark ml-1" href="#">
                <vs-chip class="text-center text-xs" transparent :color="itemStatusColorFactory(data[indextr].item_status)">
<!--                  {{ orderItemStatusNameFactory(data[indextr].item_status, data[indextr].work_orders) }}-->
                  {{ data[indextr].item_status === 'Pending' ? 'Accepted' : data[indextr].item_status }}
                </vs-chip>
                <i
                  v-if="['Submitted', 'Pending', 'In-Dispatch', 'Dispatched', 'Customer-Received', 'Returned'].includes(data[indextr].item_status)"
                  class="material-icons">
                  expand_more
                </i>
              </a>
              <vs-dropdown-menu>
                <vs-dropdown-item class="w-64"
                                  @click.stop="onClickChangeItemStatus(data[indextr].id, status.name)"
                                  v-for="status in product_order_item_statuses"
                                  v-bind:key="status.name"
                                  v-if="status.is_visible && status.before_status.includes(data[indextr].item_status) && checkDispatchStatus(data[indextr].inventory_stock, data[indextr].item_status)">
                  {{status.label}}
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <vs-chip v-if="!$can('create-edit-order')" class="text-center text-xs" transparent :color="itemStatusColorFactory(data[indextr].item_status)">
<!--              {{ orderItemStatusNameFactory(data[indextr].item_status, data[indextr].work_orders) }}-->
              {{ data[indextr].item_status === 'Pending' ? 'Accepted' : data[indextr].item_status }}
            </vs-chip>
          </vs-td>

          <vs-td>
            {{ orderItemWoStatusNameFactory(data[indextr].work_orders, []) }}
          </vs-td>

          <vs-td :data="data[indextr].is_otif">
                    <vs-chip  :color="data[indextr].is_otif ? 'success' : 'danger'">{{ data[indextr].is_otif ? 'Yes' : 'No' }}</vs-chip>
          </vs-td>

          <vs-td>
            <div class="vx-row">
              <vx-tooltip class="flex justify-start mr-2" text="Documents" position="top">
                <vs-button class="flex justify-end" @click.stop="onClickDocuments(data[indextr])"
                           size="small" color="primary" type="border" icon-pack="feather" icon="icon-paperclip"></vs-button>
              </vx-tooltip>
              <vx-tooltip class="flex justify-start mr-2" text="Item log" position="top">
                <vs-button class="flex justify-end" @click.stop="onClickViewItemLog(data[indextr].id)"
                           size="small" color="warning" type="border" icon-pack="feather" icon="icon-file-text"></vs-button>
              </vx-tooltip>
<!--              v-if="!data[indextr].item_status"-->
<!--              <vx-tooltip v-if="data[indextr].work_orders.length === 0 && $can('create-edit-order')"  class="flex justify-start mr-2" text="Update item Qty" position="top">-->
<!--                <vs-button class="flex justify-end" @click.stop="onClickUpdateProductOrder(data[indextr])"-->
<!--                           size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>-->
<!--              </vx-tooltip>-->
              <vx-tooltip
                v-if="checkWasteItemExists(data[indextr]) && $can('create-edit-order')"  class="flex justify-start mr-2" text="Create finished product waste" position="top">
                <vs-button class="flex justify-end"
                           @click="onClickCreateProductWaste(data[indextr])"
                           size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash"></vs-button>
              </vx-tooltip>
              <vx-tooltip class="flex justify-start mr-2" text="Change Requests" position="top" v-if="data[indextr].change_requests.length > 0">
                <vs-button class="flex justify-end" @click.stop="onClickViewChangeRequests(data[indextr].change_requests, data[indextr].formulation_id)"
                           size="small" color="warning" type="filled" icon-pack="feather" icon="icon-alert-triangle"></vs-button>
              </vx-tooltip>
              <vx-tooltip class="flex justify-start mr-2" text="This FG is no longer available in Production" position="top" v-if="data[indextr].formulation_status !== 'Production'">
                <vs-button class="flex justify-end" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-alert-triangle"></vs-button>
              </vx-tooltip>
<!--              <vx-tooltip v-if="data[indextr].item_status === 'Pending'"  class="flex justify-start mr-2" text="Assign a Formulation Stock Inventory" position="bottom">-->
<!--                <vs-button class="flex justify-end"-->
<!--                           size="small" color="primary" type="border" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>-->
<!--              </vx-tooltip>-->
<!--              <vx-tooltip v-if="['In-Dispatch', 'Dispatched'].includes(data[indextr].item_status)"  class="flex justify-start mr-2" text="Shipment Manage" position="bottom">-->
<!--                <vs-button @click.stop="onClickCreateCourierShipment()" class="flex justify-end"-->
<!--                           size="small" color="warning" type="border" icon-pack="feather" icon="icon-archive"></vs-button>-->
<!--              </vx-tooltip>-->
            </div>
          </vs-td>

          <template class="expand-user" slot="expand">
            <div class="con-expand-users w-4/5">
              
              <vx-card cardBorder class="my-4" title="Customer order summary">
                <div class="vx-row">
                  <div class="vx-col leading-8 font-bold pl-8">
                    <p>Ordered volume (kg) : {{ data[indextr].quantity }}</p>
                    <p>Allocated FG stock (kg) : {{ data[indextr].summary.allocated_quantity | remove_trailing_zeros}}</p>
                    <p>The manufactured quantity (kg) : {{ totalManufacturedWoQty(data[indextr].work_orders) }}</p>
                    <p>Sent to customer (kg) : {{ Number(data[indextr].summary.quantity_sent_to_customer)}}</p>
                    <p>Balance to be sent (kg) : {{ Number(data[indextr].summary.pending_booking_dispatch_to_customer)}}</p>
                    <p>Returned By Customer (kg) : {{getTotalQuantity(data[indextr]) }}</p>
                  </div>
                </div>
              </vx-card>

              <vx-card title="WO Manufacturing Quantity" cardBorder class="mb-4 mt-4">
                <vs-table :data="data[indextr].work_orders">

                  <template slot="thead">
                    <vs-th>WORK ORDER DATE</vs-th>
                    <vs-th>WORK ORDER</vs-th>
                    <vs-th>WO ALLOCATED QTY (KG)</vs-th>
                    <vs-th>WO STATUS</vs-th>
                    <vs-th>QC STATUS</vs-th>
                    <vs-th>ACTIONS</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="index_wo" v-for="(tr_wo, index_wo) in data">

                      <vs-td :data="tr_wo.work_order_date">
                        {{ tr_wo.work_order_date }}
                      </vs-td>

                      <vs-td class="text-primary font-semibold cursor-pointer" :data="tr_wo.work_order_code">
                        <vx-tooltip :text="'View '+tr_wo.work_order_code" position="top">
                          <a @click="onCLickViewWorkOrder(tr_wo.id)">{{ tr_wo.work_order_code }}</a>
                        </vx-tooltip>
                      </vs-td>

                      <vs-td :data="tr_wo.completed_quantity">
                        {{ Number(tr_wo.completed_quantity).toFixed(3) }}
                      </vs-td>

                      <vs-td class="text-sm"  :data="tr_wo.status">
                        {{ tr_wo.status }}
                      </vs-td>

                      <vs-td class="text-sm"  :data="tr_wo.qc_status">
                        {{ tr_wo.qc_status }}
                      </vs-td>

                      <vs-td>
                        <vx-tooltip v-if="tr_wo.qc_status === 'Approved by QC'" class="flex justify-start mr-2" text="Download cofa pdf" position="top">
                          <vs-button class="flex justify-end"
                                    @click="onClickCofaDownload(tr_wo.id, tr.formulation_type)"
                                    size="small" color="primary" type="border" icon-pack="feather" icon="icon-download"></vs-button>
                        </vx-tooltip>
                      </vs-td>
                    </vs-tr>
                  </template>

                </vs-table>          
              </vx-card>

              <vx-card title="WO Breakdown by Shipment Activity" cardBorder class="mb-4" v-if="data[indextr].inventory_stock.length > 0">
                <template slot="actions">
                  <div class="flex">
                          <vs-button class=""
                            v-if="isCanCreateReturnInventory(tr.return_stock, tr.inventory_stock, tr.courier_shipments) && $can('create-edit-return-product-inventory')"
                            @click.stop="onClickCreateReturnStockInventory(tr.return_stock, tr.inventory_stock)"
                            color="warning" size="" type="filled" >Create a Customer Return</vs-button>
                    </div>
                </template>
                <vs-table class="mt-8" :data="data[indextr].inventory_stock">

                  <template slot="thead">
                    <vs-th>WORK ORDER</vs-th>
                    <vs-th>WORK ORDER STATUS</vs-th>
                    <vs-th>SHIPMENT CODE</vs-th>
                    <vs-th>WORK ORDER QC STATUS</vs-th>
                    <vs-th>WO ALLOCATED QTY (KG)</vs-th>
                    <vs-th>STOCK STATUS</vs-th>
                    <vs-th>MANUFACTURE DATE</vs-th>
                    <vs-th>EXPIRATION DATE</vs-th>
                    <vs-th>WO EDIT DATE</vs-th>
                    <vs-th width="10%"></vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :id="`stock_${tr_stock.id}`" :state="tr_stock.state ? tr_stock.state : '' " :key="index_stock" v-for="(tr_stock, index_stock) in data">

                      <vs-td class="text-primary font-semibold cursor-pointer" :data="tr_stock.work_order_code">
                        <vx-tooltip :text="'View '+tr_stock.work_order_code" position="top">
                          <a @click="onCLickViewWorkOrder(tr_stock.work_order_id)">{{ tr_stock.work_order_code }}</a>
                        </vx-tooltip>
                      </vs-td>

                      <vs-td class="text-sm"  :data="tr_stock.work_order_status.name">
                        {{ tr_stock.work_order_status.name}}
                      </vs-td>

                      <vs-td>
                        {{ tr_stock.courier_shipment ?  tr_stock.courier_shipment.courier_shipment_code : 'N/A' }}
                      </vs-td>

                      <vs-td class="text-sm"  :data="tr_stock.work_order_qc_status">
                        {{ tr_stock.work_order_qc_status || 'N/A' }}
                      </vs-td>

                      <vs-td :data="tr_stock.completed_quantity">
                        {{ Number(tr_stock.completed_quantity).toFixed(3) }}
                      </vs-td>

                      <vs-td :data="tr_stock.status">
                        {{ tr_stock.status | stock_status_format }}
                      </vs-td>

                      <vs-td class="text-sm"  :data="tr_stock.manufacture_date">
                        {{ tr_stock.manufacture_date }}
                      </vs-td>

                      <vs-td class="text-sm"  :data="tr_stock.expiration_date">
                        {{ tr_stock.expiration_date }}
                      </vs-td>

                      <vs-td>
                        {{ __dateTimeFormatterToDate(tr_stock.created_at) }}
                      </vs-td>

                      <vs-td>
                        <div class="vx-row">
                          <vx-tooltip v-if="tr_stock.status === 'Pending Dispatch'" class="flex justify-start mr-2" text="Un-allocate stock" position="top">
                            <vs-button class="flex justify-end" @click.stop="onClickUnAllocateStock(tr_stock.id)"
                                      size="small" color="warning" type="border" icon-pack="feather" icon="icon-corner-up-left"></vs-button>
                          </vx-tooltip>
                          <vx-tooltip v-if="tr_stock.return_stock_inventory.length > 0" class="flex justify-start mr-2" text="View Return Stock" position="top">
                            <vs-button class="flex justify-end"
                                      size="small" color="danger" type="border" icon-pack="feather" icon="icon-rotate-cw"></vs-button>
                          </vx-tooltip>
                          <vx-tooltip v-if="!!tr_stock.linked_return_inventory" class="flex justify-start mr-2" text="View Reallocated Stock" position="top">
                            <vs-button @click.stop="onClickLink(tr_stock.linked_return_inventory.formulation_stock_inventory_id, tr_stock.linked_return_inventory.id)" class="flex justify-end"
                                      size="small" color="warning" type="border" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>
                          </vx-tooltip>
                        </div>
                      </vs-td>
                      
                      <template class="expand-user" slot="expand">
                        <div class="con-expand-users w-4/5">
                          <return-stock-table 
                            v-on:refreshData="refreshItems"
                            v-on:onClickHighlightReturnStock="onClickHighlightReturnStock" 
                            :return_stock="tr_stock.return_stock_inventory"
                            :formulation_type="tr.formulation_type" 
                            :formulation_id="tr.formulation_id"
                          />
                        </div>
                      </template>

                    </vs-tr>
                  </template>

                </vs-table>
              </vx-card>

              <!-- <vx-card title="Return Stock" cardBorder class="mb-4" v-if="isCanDisplayReturnStockSection(data[indextr]) && $can('view-return-product-inventory')">
                <template slot="actions">
                  <div class="flex">
                          <vs-button class=""
                            v-can="'create-edit-raw-material-orders-qc-test'"
                            v-if="isCanCreateReturnInventory(tr.return_stock, tr.inventory_stock, tr.courier_shipments) && $can('create-edit-return-product-inventory')"
                            @click.stop="onClickCreateReturnStockInventory(tr.return_stock, tr.inventory_stock)"
                            color="primary" size="small" type="border" >Create Return Product Inventory</vs-button>
                    </div>
                </template>
                <vs-table class="mt-8" :data="data[indextr].return_stock">

                  <template slot="thead">
                    <vs-th>DATE/TIME</vs-th>
                    <vs-th>WORK ORDER</vs-th>
                    <vs-th>RETURN STOCK STATUS</vs-th>
                    <vs-th>STOCK QUANTITY (KG)</vs-th>
                    <vs-th>QUANTITY REASSIGNED</vs-th>
                    <vs-th>QUANTITY SENT TO DISPATCH</vs-th>
                    <vs-th>ACTION</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="index_return" v-for="(tr_return, index_return) in data">

                      <vs-td>
                          {{ __dateTimeFormatter(tr_return.created_at) }}
                      </vs-td>

                      <vs-td class="text-primary font-semibold cursor-pointer" :data="tr_return.work_order">
                        <vx-tooltip :text="'View '+tr_return.work_order" position="top">
                          <a @click="onCLickViewWorkOrder(tr_return.work_order_id)">{{ tr_return.work_order }}</a>
                        </vx-tooltip>
                      </vs-td>

                      <vs-td class="text-sm"  :data="tr_return.status">
                        {{ tr_return.status}}
                      </vs-td>

                      <vs-td :data="tr_return.quantity">
                        {{ Number(tr_return.quantity).toFixed(4) }}
                      </vs-td>

                      <vs-td class="text-sm"  :data="tr_return.is_quantity_reassigned">
                        {{ tr_return.is_quantity_reassigned ? "YES" : "NO" }}
                      </vs-td>

                      <vs-td class="text-sm"  :data="tr_return.is_quantity_sent_to_dispatch">
                        {{ tr_return.is_quantity_sent_to_dispatch ? "YES" : "NO" }}
                      </vs-td>

                      <vs-td>
                        <div class="vx-row">
                          <vx-tooltip v-if="tr_return.status === 'QC Pending' && $can('create-return-product-qc-test')" class="flex justify-start mr-2" text="Create Return Stock QC Test" position="top">
                          <vs-button class="flex justify-end"
                                    @click="onClickCreateReturnStockQc(tr_return.id, tr.formulation_type, tr.formulation_id)"
                                    size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip v-if="tr_return.status === 'QC Pending' && $can('create-return-product-qc-test')" class="flex justify-start mr-2" text="QC Not Required" position="top">
                          <vs-button class="flex justify-end"
                                    @click="onClickReturnStockQcNotRequired(tr_return.id)"
                                    size="small" color="warning" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                        </vx-tooltip>
                        </div>
                      </vs-td>

                    </vs-tr>
                  </template>

                </vs-table>
              </vx-card> -->

              <vx-card title="All Dispatched Shipments from this WO" cardBorder class="mb-4">
                <vs-table class="mt-8" :data="data[indextr].courier_shipments">

                  <template slot="thead">
                    <vs-th>SHIPMENT CODE</vs-th>
                    <vs-th>BOOKING REF NUMBER</vs-th>
                    <vs-th>DATE OF BOOKING</vs-th>
                    <vs-th>QUANTITY (KG)</vs-th>
                    <vs-th>ESTIMATED DELIVERY DATE</vs-th>
                    <vs-th>COST OF DELIVERY (Excl VAT) in GBP</vs-th>
                    <vs-th>SHIPMENT STATUS</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="index_sh" v-for="(tr_sh, index_sh) in data">

                      <vs-td :data="tr_sh.courier_shipment_code">
                        <vx-tooltip :text="'View '+tr_sh.courier_shipment_code" position="top">
                          <span @click="onClickViewShipment(tr_sh.id)" class="text-primary cursor-pointer">{{ tr_sh.courier_shipment_code }}</span>
                        </vx-tooltip>
                      </vs-td>

                      <vs-td :data="tr_sh.booking_reference_number">
                        {{ tr_sh.booking_reference_number }}
                      </vs-td>

                      <vs-td :data="tr_sh.date_of_booking">
                        {{ tr_sh.date_of_booking }}
                      </vs-td>

                      <vs-td :data="tr_sh.quantity">
                        {{ Number(tr_sh.quantity).toFixed(3) }}
                      </vs-td>

                      <vs-td :data="tr_sh.estimated_delivery_date">
                        {{ tr_sh.estimated_delivery_date }}
                      </vs-td>

                      <vs-td :data="tr_sh.cost_of_delivery">
                        {{ tr_sh.cost_of_delivery }}
                      </vs-td>

                      <vs-td class="text-sm" :data="tr_sh.status">
                        {{ tr_sh.status }}
                      </vs-td>

                    </vs-tr>
                  </template>

                </vs-table>
              </vx-card>

              <vx-card title="Product Item Waste" cardBorder class="mb-4" v-if="data[indextr].product_item_waste.length > 0">
                <vs-table  class="mt-8" :data="data[indextr].product_item_waste">

                  <template slot="thead">
                    <vs-th>WORK ORDER</vs-th>
                    <vs-th>QUANTITY (KG)</vs-th>
                    <vs-th>STATUS</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="index_waste" v-for="(tr_waste, index_waste) in data">

                      <vs-td :data="tr_waste.work_order_id">
                        {{ tr_waste.work_order_id }} WO-CODE
                      </vs-td>

                      <vs-td :data="tr_waste.quantity">
                        {{ Number(tr_waste.quantity).toFixed(2) }}
                      </vs-td>

                      <vs-td :data="tr_waste.status">
                        {{ tr_waste.status }}
                      </vs-td>

                    </vs-tr>
                  </template>

                </vs-table>
              </vx-card>
            </div>
          </template>

        </vs-tr>
        <vs-tr>
          <vs-td></vs-td>
          <vs-td style="font-weight: bolder">Total</vs-td>
          <vs-td colspan="8"></vs-td>
          <vs-td style="font-weight: bolder">{{totalCalculator()}}</vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
          <vs-td></vs-td>
        </vs-tr>
      </template>

    </vs-table>

    <update-product-order-items-pop-up v-on:refreshItems="refreshItems" ref="updateProductOrderItemsPopUp" />
    <!-- <create-product-order-shipment-pop-up ref="createProductOrderShipmentPopUp"/> -->
    <product-order-item-document-pop-up ref="productOrderItemDocumentPopUp"/>
    <create-product-waste-pop-up ref="createProductWastePopUp"/>
    <view-product-order-item-log-pop-up ref="viewProductOrderItemLogPopUp"/>
    <product-order-cofa-document-pop-up ref="productOrderCofaDocumentPopUp"/>
    <create-return-inventory-pop-up v-on:refreshItems="refreshItems" ref="createReturnInventoryPopUp" />
    <create-return-stock-qc-test-pop-up v-on:refreshData="refreshItems" ref="createReturnStockQcTestPopUp"/>
    <view-product-order-item-change-requests-pop-up v-on:refreshItems="refreshItems" ref="viewProductOrderItemChangeRequestsPopUp"/>
    <vs-prompt
      title="ENTER REASON CODE FOR CANCEL"
      acceptText="Save"
      @cancel="active_vam_reason_code_prompt = false"
      @accept="changeItemStatus([selected_item_for_update.id, selected_item_for_update.status, selected_vam_reason_codes])"
      @close="active_vam_reason_code_prompt = false"
      :active.sync="active_vam_reason_code_prompt">
      <div class="con-exemple-prompt">
        <span>VAM Reason Code</span>
        <v-select :clearable="true" placeholder="" v-model="selected_vam_reason_codes" :appendToBody="false"
              :options="vam_reason_codes" label="name" :reduce="option => option.name"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" class="" multiple></v-select>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const IncotermRepository = RepositoryFactory.get('incoterm');
  const InventoryRepository = RepositoryFactory.get('inventory');
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  const CrmRepository = RepositoryFactory.get('crm');
  import UpdateProductOrderItemsPopUp from '@/components/popups/customer/product-orders/UpdateProductOrderItemsPopUp'
  import ProductOrderItemDocumentPopUp from "@/components/popups/customer/product-orders/ProductOrderItemDocumentPopUp";
  import CreateProductOrderShipmentPopUp
    from "@/components/popups/customer/product-orders/CreateProductOrderShipmentPopUp";
  import ViewProductOrderItemLogPopUp
    from "@/components/popups/customer/product-orders/item-log/ViewProductOrderItemLogPopUp";
  import CreateProductWastePopUp from "@/components/popups/customer/product-orders/CreateProductWastePopUp";
  import ProductOrderCofaDocumentPopUp
    from "@/components/popups/customer/product-orders/documents/ProductOrderCofaDocumentPopUp";
  import router from '@/router.js'
  import {product_order_item_statuses} from '@/constants/statuses'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Utils from "@/mixins/Utils";
  import CreateReturnInventoryPopUp from '@/components/popups/customer/product-orders/order-return/CreateReturnInventoryPopUp.vue';
import CreateReturnStockQcTestPopUp from '@/components/popups/customer/product-orders/order-return/CreateReturnStockQcTestPopUp.vue';
  import ReturnStockTable from './components/ReturnStockTable.vue';
  import ViewProductOrderItemChangeRequestsPopUp from '@/components/popups/customer/product-orders/change-requests/ViewProductOrderItemChangeRequestsPopUp.vue';
  import vSelect from 'vue-select'

  export default {
    name: "ProductOrderTable",
    mixins : [SuccessMessage, ErrorMessages, Utils],
    props: {
      items: {
        type: Array,
        default: []
      },
      account_currency: {
        type: String,
        default: 'GBP'
      },
      id: {
        default: ''
      },
      statusId: {
        default: ''
      },
      customerId: {
        type: String
      },
      is_item_status_handled_individually: {
        type: Boolean,
        default : false
      },
      is_proforma_account: {
        type: Boolean,
        default: false
      },
      orderInvoices: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        product_order_item_statuses: product_order_item_statuses,
        incoterms: [],
        active_vam_reason_code_prompt: false,
        selected_vam_reason_codes: [],
        vam_reason_codes: [],
        selected_item_for_update: {}
      }
    },
    components: {
    UpdateProductOrderItemsPopUp,
    CreateProductOrderShipmentPopUp,
    ProductOrderItemDocumentPopUp,
    CreateProductWastePopUp,
    ViewProductOrderItemLogPopUp,
    ProductOrderCofaDocumentPopUp,
    CreateReturnInventoryPopUp,
    CreateReturnStockQcTestPopUp,
    ReturnStockTable,
    ViewProductOrderItemChangeRequestsPopUp,
    'v-select': vSelect,
},
    methods: {
      async refreshItems() {
        this.$emit('refresh')
      },
      totalCalculator() {
        let total = 0;
        this.product_order_items.forEach((m) => {
          if (!!m.price && m.item_status !== 'Cancelled') {
            total = total + Number(m.price) * Number(m.quantity)
          }

        })
        return total.toFixed(2)
      },
      onClickFinishedProduct(id) {
        router.push({path: `/pages/formulations/${id}`})
      },
      async onClickUpdateProductOrder(data) {
        await this.$refs.updateProductOrderItemsPopUp.openPopup(this.id, this.customerId)
      },
      async onClickCreateProductWaste(data) {
        await this.$refs.createProductWastePopUp.openPopup(data.id, data.formulation_code, data.work_orders, data.product_item_waste)
      },
      onClickDocuments(item) {
        this.$refs.productOrderItemDocumentPopUp.openPopup(item, this.customerId)
      },
      onClickViewItemLog(id) {
        this.$refs.viewProductOrderItemLogPopUp.openPopup(id)
      },
      onClickViewChangeRequests(data, formulation_id) {
        this.$refs.viewProductOrderItemChangeRequestsPopUp.openPopup(data, formulation_id, this.customerId, this.account_currency)
      },
      onClickCofaDownload(wo_id, formulation_type) {
        this.$refs.productOrderCofaDocumentPopUp.openPopup(wo_id, formulation_type, this.customerId)
      },
      getTotalQuantity(item) {
        if (!item.return_stock || item.return_stock.length === 0) {
          return 0;
        }
        return item.return_stock.reduce((sum, item) => {
          return sum + parseFloat(item.quantity || 0);
        }, 0);
      },
      async onClickChangeItemStatus(id, status) {
        this.selected_item_for_update = {
          id, status
        }
        if(status === 'Cancelled') {
          this.active_vam_reason_code_prompt = true
          return 
        }
        if(status === 'Pending' && this.is_proforma_account && !this.isIncludedPaidInvoice) {
          this.$vs.dialog({
            color: 'danger',
            title: `Warning`,
            text: 'This is a proforma account and there does not appear to be a paid invoice against this order. ' +
              'It cannot be accepted until there is a paid invoice',
            accept: null,
            acceptText: "Close"
          })
          return
        }
        this.$vs.dialog({
            type: 'confirm',
            color: `${status !== 'Cancelled' ? 'warning' : 'danger'}`,
            title: `Confirm`,
            text: `${status !== 'Cancelled' ? 'Are you sure you want to make this change?' : 'Are you sure you want to reject this order item?'}`,
            accept: this.changeItemStatus,
            parameters: [id, status]
        })
      },
      async changeItemStatus(params) {
        await this.$vs.loading({
          container: '#order_item_table',
          scale: 0.45
        })
        try {
          let payload = {status: params[1]}
          if(params[2]) {
            payload.vam_type = params[2]
          }
          await CustomerRepository.productOrdersItemStatusChange(params[0], payload)
          await this.getProductOrderDetails()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#order_item_table > .con-vs-loading')
        if(['Part Returned', 'Returned'].includes(params[1])) {
          const find_item = this.product_order_items.find((x) => x.id === params[0])
          this.onClickCreateReturnStockInventory(find_item.return_stock, find_item.inventory_stock)
        }
      },
      async getProductOrderDetails() {
        await this.$vs.loading({
          container: '#order_item_table',
          scale: 0.45
        })
        try {
          const {data} = await CustomerRepository.getCustomerProductOrder(this.id)
          this.product_order_items = data.data.formulation_items
          this.$emit('statusChangeNotify')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#order_item_table > .con-vs-loading')

      },
      itemStatusColorFactory(status_name) {
        return 'dark'
        // const status = this.product_order_item_statuses.find((n) => n.name === status_name)
        // return status ? status.color : 'dark'
      },
      onCLickViewWorkOrder(wo_id) {
        this.$router.push({path: `/pages/manufacturing/work-orders/${wo_id}/details`})
      },
      onClickViewShipment(shipment_id) {
        this.$router.push({path: `/pages/courier-shipments?open=${shipment_id}`})
      },
      isInPackOffCompleted(arr, status) {
        const wo_status_arr = arr.map((n) => n.status)
        let count = 0
        wo_status_arr.forEach((n) => {
          if(n === 'Pack Off Completed') {
            count++
          }
        })
        return status === "In-Manufacturing" && count === 0;
      },
      // onClickCreateCourierShipment() {
      //   this.$refs.createProductOrderShipmentPopUp.openPopup(this.product_order_items)
      // },
      orderItemWoStatusNameFactory(work_orders = [], inventory_stock = []) {
        let wo_arr = work_orders.concat(inventory_stock.map((x) => { x.status = x.work_order_status.name; x.id = x.work_order_id; return x; }))
        wo_arr = wo_arr.reduce((acc, curr) => {
          const duplicate = acc.find(item => item.id === curr.id);
          if (!duplicate) {
            acc.push(curr);
          }
          return acc;
        }, []);
        if(wo_arr.length === 0) {
          return 'N/A'
        }
        if(wo_arr.length === 1) {
          return wo_arr[0].status
        }
        if(wo_arr.length > 1) {
          return 'multiple WOs'
        }
      },
      orderItemStatusNameFactory(status_name, work_orders = []) {
        if(!status_name) {
          return 'Order submitted'
        }
        if(status_name === 'Returned') {
          return status_name
        }
        if(status_name === 'In-Dispatch') {
          return status_name
        }
        if(status_name === 'Dispatched') {
          return status_name
        }
        if(status_name === 'Customer-Received') {
          return status_name
        }
        if(work_orders.length > 1) {
          return 'Multiple work orders'
        }
        if(work_orders.length === 0) {
          if(status_name === 'Cancelled') {
            return 'Ordered item rejected'
          } else if(status_name === 'Pending') {
            return 'Ordered item accepted'
          } else {
            return status_name
          }
        }
        if(work_orders.length === 1) {
          return work_orders[0].status
        }
      },
      async fetchIncoterms() {
        try {
          const { data } = (await IncotermRepository.getListOfIncoterms(1, '', 50, '')).data
          this.incoterms = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      async onClickIncoterm(incoterm, item_id) {
        try {
          await CustomerRepository.updateCustomerProductOrderItemIncoterm(item_id, { incoterm: incoterm })
          await this.getProductOrderDetails()
          this.showSuccessMessage('Incoterm update successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      checkWasteItemExists(row_data) {
        const shipments = row_data.courier_shipments
        const item_status = row_data.item_status
        const product_item_waste = row_data.product_item_waste
        const work_orders = row_data.work_orders
        const already_created_waste_qty = product_item_waste.reduce((a, b) => a + Number(b.quantity), 0)
        const total_work_orders_qty = work_orders.reduce((a, b) => a + Number(b.completed_quantity), 0)

        return (this.checkKeyHasOneSameValue(shipments, 'status', 'Returned') || item_status === 'Returned') &&
          (product_item_waste.length === 0 || total_work_orders_qty > already_created_waste_qty);
      },
      manufacturingDateFactory(work_orders) {
        const find = work_orders.find((n) => n.status === 'Pack Off Completed')
        if(find) {
          return find.work_order_date
        } else {
          return 'N/A'
        }
      },
      onClickCreateReturnStockInventory(return_stock, item_stock) {
        this.$refs.createReturnInventoryPopUp.openPopup(return_stock, item_stock)
      },
      onClickCreateReturnStockQc(return_inventory_id, formulation_type, formulation_id) {
        this.$refs.createReturnStockQcTestPopUp.openPopup(return_inventory_id, formulation_type, formulation_id)
      },
      async onClickReturnStockQcNotRequired(return_inventory_id) {
        await InventoryRepository.returnStockQcTestNotRequired(return_inventory_id)
        await this.refreshItems()
      },
      isCanDisplayReturnStockSection(item) {
        return item.return_stock.length > 0 || ['Returned' ,'Part Returned'].includes(item.item_status) ||
          this.checkKeyHasOneSameValueArray(item.courier_shipments, 'status', ['Customer Received', 'Shipment Dispatched'])
      },
      isCanCreateReturnInventory(return_stock, item_stock, courier_shipments) {
        let item_stock_array = item_stock.filter((x) => ['Part Returned', 'Returned', 'Dispatched', 'Customer-Received', 'In_Progress', 'Pending Dispatch'].includes(x.status))
        const return_total = return_stock.reduce((a, b) => a + Number(b.quantity), 0)
        const stock_total = item_stock_array.reduce((a, b) => a + Number(b.completed_quantity), 0)
        return (return_total < stock_total) && this.checkKeyHasOneSameValueArray(courier_shipments, 'status', ['Customer Received', 'Shipment Dispatched'])
      },
      onClickHighlightReturnStock(param) {
        // this.product_order_items[0].inventory_stock[1].state = 'danger'
        this.$forceUpdate();
      },
      onClickLink(stock_id, return_id) {
        let stock = document.getElementById(`stock_${stock_id}`);
        let retn = document.getElementById(`return_${return_id}`);
        [stock, retn].forEach(elem => {
          if(elem) elem.style.backgroundColor = 'rgba(234, 84, 85, 0.3)';
        });
        setTimeout(() => [stock, retn].forEach(elem => {
          if(elem) elem.removeAttribute('style');
        }), 3000);
      },
      totalManufacturedWoQty(work_orders) {
        return work_orders.filter((x) => ['Pack Off Completed', 'Mix Completed', 'Pack Off In Progress'].includes(x.status) && x.qc_status === 'Approved by QC')
          .reduce((a, b) => a + Number(b.completed_quantity), 0)
      },
      async onClickUnAllocateStock(id) {
        await this.$vs.loading({
          container: '#order_item_table',
          scale: 0.45
        })
        try {
          await ManufacturingRepository.unAllocateFormulationStockInventory(id)
          this.showSuccessMessage('Unallocated Successfully')
        } catch (error) {
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close('#order_item_table > .con-vs-loading')
        await this.refreshItems()
      },
      checkDispatchStatus(stock, status) {
        if(status !== 'In-Dispatch') return true
        return stock.some((x) => x.status === 'Dispatched')
      },
      async fetchVamReasonCodeList() {
        try {
          const { data } = (await CrmRepository.getListVamType()).data
          this.vam_reason_codes = data
        } catch (error) {
          
        }
      }
    },
    async mounted() {
      await this.fetchIncoterms()
      await this.fetchVamReasonCodeList()
    },
    computed: {
      isIncludedPaidInvoice: function() {
        if(this.orderInvoices.length === 0) {
          return false
        }
        return this.orderInvoices.some((obj) => { return obj.status.name === 'Paid' })
      },
      product_order_items: function() {
        return this.items
      },
    },
    watch: {
      items: function (new_value, old_value) {
        this.product_order_items = new_value
      }
    },
  }
</script>

<style scoped>

</style>
